<template>
  <base-edit></base-edit>
</template>

<script>
  import baseEdit from './baseEdit';

  export default {
    name: 'businessOrderAdd',
    components: {
      baseEdit,
    },
  };
</script>
